<div class="form-row">
  <div class="form-group col-md-4">
    <label for="inputEmail4">First Name</label>
    <input type="text" name='name' [(ngModel)]='this.user.firstName' [class.is-invalid]='!this.user.firstName' class="form-control" id="inputEmail4">
  </div>
  <div class="form-group col-md-4">
    <label for="inputPassword4">Middle Name</label>
    <input type="text" name='registration' [(ngModel)]='this.user.middleName' class="form-control" id="inputPassword4">
  </div>
  <div class="form-group col-md-4">
    <label for="inputPassword4">Last Name</label>
    <input type="text" name='vinNumber' [(ngModel)]='this.user.lastName' [class.is-invalid]='!this.user.lastName' class="form-control" id="inputPassword4">
  </div>
  <div class="form-group col-md-4">
    <label for="inputPassword4">Email</label>
    <input type="text" name='make' [(ngModel)]='this.user.email' [class.is-invalid]='!this.user.email' class="form-control" id="inputPassword4">
  </div>
  <div class="form-group col-md-4">
    <label for="inputPassword4">Password</label>
    <input type="password" name='vinNumber' [(ngModel)]='this.user.password' [class.is-invalid]='!this.user.password && this.user.id === -1' class="form-control" id="inputPassword4">
  </div>
  <div class="form-group col-md-4">
    <label for="inputPassword4">User Group</label>
    <select class='form-control' [class.is-invalid]='this.user.userGroupId === -1' (change)='this.onGroupChanged(+$event.target.value)'>
      <option value='-1'>Select a user group</option>
      @for (item of this.groups; track item) {
        <option [value]='item.id' [selected]='this.user.userGroupId === item.id'>{{ item.name }}</option>
      }
    </select>
  </div>
  @if (this.isCustomerGroup()) {
    <div class="form-group col-md-4">
      <label>Customer</label>
      <select class='form-control' [class.is-invalid]='!(this.user.accountId > 0)' (change)='this.user.accountId = +$event.target.value'>
        <option value='-1'>Choose the customer this login belongs to</option>
        @for (item of this.accounts; track item.id) {
          <option [value]='item.id' [selected]='this.user.accountId === item.id'>{{ item.name }}</option>
        }
      </select>
      <small class="text-muted">Customer portal login - it cannot sign in to Logixi.</small>
    </div>
  }
  <div class="form-group col-md-4">
    <label>Active</label>
    <div class="form-check">
      <input type="checkbox" class="form-check-input" id="userActive" [(ngModel)]='this.user.active'>
      <label class="form-check-label" for="userActive">Can sign in</label>
    </div>
  </div>
  <div class="form-group col-md-4">
    <label for="inputPassword4">Driver (Not required)</label>
    <select class='form-control' (change)='this.user.driverId = +$event.target.value;'>
      <option value='-1'>Select a driver</option>
      @for (item of this.drivers; track item) {
        <option [value]='item.id' [selected]='this.user.driverId === item.id'>{{ item.firstName }} {{ item.lastName }}</option>
      }
    </select>
  </div>
  <div class="form-group col-md-4">
    <label for="inputPassword4">Fitter (Not required)</label>
    <select class='form-control' (change)='this.user.fitterId = +$event.target.value;'>
      <option value='-1'>Select a Fitter</option>
      @for (item of this.fitters; track item) {
        <option [value]='item.id' [selected]='this.user.fitterId === item.id'>{{ item.firstName }} {{ item.lastName }}</option>
      }
    </select>
  </div>




</div>

<br />
<br />
<h3 class='header'>Skills</h3>
<br />
<br />

<div class="form-group col-md-4">
  <label for="inputPassword4">Default Timeline</label>
  <select class='form-control' (change)='setDefaultTimeline($event)'>
    <option value='-1'>Select a timeline</option>
    @for (item of this.orderTypes; track item) {
      <option [value]='item.id' [selected]='this.getPrimarySKillId() === item.id'>{{ item.name }}</option>
    }
  </select>
</div>

<table class='table'>
  <thead>
    <tr>
      <td>Skill type</td>
      <th>Has Skill?</th>
    </tr>
  </thead>
  <tbody>
    @for (userSkill of this.userSkills; track userSkill) {
      <tr>
        <td>{{ userSkill.orderType.name }}</td>
        <td><input type='checkbox' [(ngModel)]="userSkill.active"/></td>
      </tr>
    }
  </tbody>
</table>
